import get from 'lodash/get'
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'
import {
  hasAdminPrivilege,
  getUserInfo,
  getProfile,
  getRemainingRequests
} from '../services/api/user'
import { getAffiliateUser } from '../services/api/affiliate'
import { availableFeatures } from '../services/api/subscription'

export const calculateProfileCompleteness = (profile) => {
  const requiredKeys = ['full_name', 'bio']
  const completenessPerKey = 25
  const optionalKeys = ['role', 'imdb', 'twitter', 'instagram', 'threads']

  let completeness = 0

  requiredKeys.forEach(key => {
    if (profile[key]) completeness += completenessPerKey
  })

  const hasOptionalKey = optionalKeys.some(key => profile[key])
  if (hasOptionalKey) {
    completeness += 50 // At least one of imdb, twitter, instagram, threads contributes 60% completeness
  }
  return completeness
}

export const mutateUserData = async (storedUser) => {
  const [subscriptionInfo, adminPrivilege, user, affiliate, profile, remainingRequests] = await Promise.all([
    availableFeatures(),
    hasAdminPrivilege(),
    getUserInfo(),
    getAffiliateUser(),
    getProfile(),
    getRemainingRequests()
  ])
  const subscriptionPlan = subscriptionInfo.features[0].type
  storedUser.userUuid = user.userUuid
  storedUser.userBlocked = user.userBlocked
  storedUser.hasAdminPrivilege = adminPrivilege.hasPrivilege
  storedUser.features = subscriptionInfo.features
  storedUser.earlyAccess = subscriptionInfo.earlyAccess
  storedUser.subscriptionData = subscriptionInfo.subscription
  storedUser.onDemandData = subscriptionInfo.onDemand
  storedUser.subscriptionPlan = subscriptionPlan
  storedUser.subscriptionStatus = get(subscriptionInfo, 'subscription.data.status', 'Active')
  storedUser.affiliate = affiliate
  storedUser.credits = user.credits
  storedUser.totalScripts = user.totalScripts
  storedUser.profile = {
    profile_name: storedUser.displayName,
    ...profile
  }
  storedUser.remainingRequests = remainingRequests
  storedUser.profileCompleteness = calculateProfileCompleteness(storedUser.profile)
  if (storedUser.subscriptionStatus === 'incomplete') {
    const failedExpiredDate = addDays(new Date(storedUser.subscriptionData.data.current_period_start * 1000), 1)
    storedUser.failedExpiredAt = format(failedExpiredDate, 'MMM dd, yyyy')
  }
  if (!storedUser.subscriptionData && storedUser.onDemandData) {
    storedUser.onDemandData.forEach(feature => {
      const featureIndex = storedUser.features.findIndex(f => f.name === feature.product_name)
      if (featureIndex > -1) {
        storedUser.features[featureIndex].enabled = true
      }
    })
    storedUser.unpaidOrder = storedUser.onDemandData.find(p => p.unpaidInvoice)
    if (storedUser.unpaidOrder) {
      const failedExpiredDate = addDays(new Date(storedUser.unpaidOrder.data.current_period_start * 1000), 1)
      storedUser.failedExpiredAt = format(failedExpiredDate, 'MMM dd, yyyy')
    }
  }

  if (storedUser.earlyAccess && storedUser.earlyAccess.length) {
    storedUser.earlyAccess.forEach(feature => {
      const featureIndex = storedUser.features.findIndex(f => f.name === feature)
      if (featureIndex > -1) {
        storedUser.features[featureIndex].enabled = true
      }
    })
  }

  return storedUser
}
